import { DedicatedBookingPage } from "@/components/booking/DedicatedBookingPage";

export default function BookingCorporate() {
  return <DedicatedBookingPage service="corporate" />;
}
